// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-work[data-v-8be369c8]{position:fixed;bottom:20px;right:20px;z-index:1000;background:transparent;border:none;padding:0;cursor:pointer}.button-img[data-v-8be369c8]{width:85px;height:auto;-o-object-fit:contain;object-fit:contain;transition:transform .2s ease-in-out}.button-img[data-v-8be369c8]:hover{transform:scale(1.1)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
